export default __webpack_public_path__ + "static/media/hero-handbook.dff294d1.png";